<template>
  <nav class="result-nav" role="navigation">
    <ul class="result-nav-list">
      <li>
        <a :class="{ active: activeNavType === 'workoutplan' }" href="/my/programs">
          {{ userAuthStore.features.EXCLUSIVE_PLANS ? 'My Programs & Challenges' : 'My Programs' }}
        </a>
      </li>
      <li>
        <a :class="{ active: activeNavType === 'mealplan' }" href="/my/meal-plans">My Meal Plans</a>
      </li>
      <li>
        <a :class="{ active: activeNavType === 'pilot' }" href="/my/pilot-programs"
          >My Pilot Programs</a
        >
      </li>
      <li v-if="userAuthStore.features.ROUTINES">
        <a :class="{ active: activeNavType === 'routine' }" href="/my/routines">My Routines</a>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { useUserAuthStore } from '@/stores/user-auth'

/**
 * Used on the "my programs" page in the search expander
 */
withDefaults(
  defineProps<{
    activeNavType: 'routine' | 'pilot' | 'workoutplan' | 'mealplan'
  }>(),
  {
    activeNavType: 'workoutplan',
  },
)

/** STATE **/
const userAuthStore = useUserAuthStore()
</script>
